import { loadScript } from '@golden/shared';
import { Lang } from './types';
import { NetEasyError } from './NetEasyError';
import { NowTime } from '@golden/gdk-base';
export let isNetEasyInited = false;
export const initNetEasy = async (element, captchaId, overrideOptions = {}) => {
    const load = async () => {
        const timeStamp = Math.floor(NowTime.get().getTime() / 1000); // getTime 回傳是毫秒單位，除以 1000 化為秒
        const timeStampToNearestMinute = timeStamp - (timeStamp % 60);
        if (!isNetEasyInited) {
            try {
                await loadScript(`https://cstaticdun.126.net/load.min.js?t=${timeStampToNearestMinute}`);
                isNetEasyInited = true;
            }
            catch (e) {
                throw new Error('net easy scripts load failed');
            }
        }
    };
    let resolveValidationPromise;
    let rejectValidationPromise;
    const init = async () => await new Promise((resolve, reject) => {
        if (!window.initNECaptcha) {
            reject(new NetEasyError('init', 'net easy scripts load failed'));
            return;
        }
        window.initNECaptcha({
            element,
            captchaId,
            lang: Lang.ZH_CN,
            apiVersion: 2,
            width: '320px',
            mode: 'popup',
            onVerify: (err, data) => {
                if (err)
                    return;
                resolveValidationPromise(data);
            },
            onClose: () => {
                rejectValidationPromise(new NetEasyError('close', { message: 'user close' }));
            },
            popupStyles: {
                position: 'fixed',
                top: '25%',
                left: 'calc(50% - 175px)'
            },
            ...overrideOptions
        }, (instance) => {
            resolve(instance);
        }, (e) => {
            reject(new NetEasyError('init', e));
        });
    });
    await load();
    const captcha = await init();
    const show = async (_fail = (error) => { console.log(error); }) => await new Promise((resolve, reject) => {
        captcha.verify();
        resolveValidationPromise = resolve;
        rejectValidationPromise = reject;
    });
    // eslint-disable-next-line @typescript-eslint/require-await
    const reset = async () => {
        captcha.refresh();
    };
    // eslint-disable-next-line @typescript-eslint/require-await
    const destroy = async () => {
        captcha.destroy();
    };
    return {
        reset,
        destroy,
        show
    };
};
export * from './types';
export { NetEasyError } from './NetEasyError';
//# sourceMappingURL=index.js.map